<div style="width: 100%; max-height: 100%; display: flex; flex-direction: column; overflow: hidden; position: relative;" data-cy="instant-messaging-container">
  @if (!isDisableHeader) {
    <div class="im-header" (click)="onOpenInstantMessaging()" data-cy="instant-messaging-header">
      <div [ngStyle]="{'text-align': isMinimized ? 'center' : 'left', 'max-width': isMinimized ? '100%' : '20px', 'flex-basis': isMinimized ? '100%' : '20px'}"
        style="margin-left: auto; margin-right: auto;" data-cy="instant-messaging-icon-container">
        <div style="width: 20px; margin-left: auto; margin-right: auto;"
          [matBadge]="instantMessages.length" matBadgeSize="small" [matBadgeHidden]="instantMessages.length === 0"
          matTooltip="Open Instant Messaging" data-cy="instant-messaging-badge">
          <lucide-icon name="message-circle" [size]="20" data-cy="instant-messaging-icon"></lucide-icon>
        </div>
      </div>
      @if (!isMinimized) {
        @if (instantMessages.length === 0) {
          <div class="im-header-label im-header-label-empty" data-cy="instant-messaging-no-messages">No new messages</div>
        } @else {
          <div class="im-header-label" data-cy="instant-messaging-message-count">
            {{instantMessages.length}} new message{{instantMessages.length === 1 ? '' : 's'}}
          </div>
        }
      }
    </div>
  }
  @if (instantMessages.length > 0) {
    <div style="flex: 1; overflow-y: auto;"
      [ngStyle]="{'width': isMinimized ? '40px' : '320px', 'max-width': isMinimized ? '40px' : '320px'}"
      data-cy="instant-messaging-messages-container">
      @for (page of instantMessages; track page.dataNotification.NotificationID) {
        <div class="im-message-item"
          (click)="onNotificationSeenClick(page.dataNotification, true)"
          matTooltip="Mark as read"
          [matTooltipDisabled]="hoveredThreadIconId === page.dataNotification.NotificationID"
          [ngStyle]="{'backgroundColor': getBackgroundColor(page.UserID), 'color': getForColor(page.UserID), 'height': isMinimized ? '40px' : 'auto'}"
          data-cy="instant-messaging-message-item">

          @if (isMinimized) {
            <div class="im-initials"
              [matTooltip]="'To: ' + getName(page.UserID) + ' · From: ' + getName(page.dataNotification.SenderUserID) + ' · ' + page.dataNotification.Message"
              data-cy="instant-messaging-minimized-initials">{{getInitials(page.UserID)}}</div>
          } @else {
            <button type="button" matTooltip="Open conversation" aria-label="Open conversation"
              (mouseenter)="hoveredThreadIconId = page.dataNotification.NotificationID"
              (mouseleave)="hoveredThreadIconId = null"
              (click)="$event.stopPropagation(); onOpenInstantMessaging(page)"
              class="thread-icon" data-cy="instant-messaging-thread-icon">
              <lucide-icon name="message-circle" [size]="16"></lucide-icon>
            </button>
            <div class="im-message-body" data-cy="instant-messaging-message-content">
              @if (isCurrentUser(page.UserID)) {
                <div class="im-message-text" data-cy="instant-messaging-message-text">
                  <span class="im-name">{{getName(page.dataNotification.SenderUserID)}}</span>: {{page.dataNotification.Message}}
                </div>
              } @else {
                <div class="im-message-text" data-cy="instant-messaging-message-text">
                  → <span class="im-name">{{getName(page.UserID)}}</span>: {{page.dataNotification.Message}}
                </div>
              }
              <div class="im-message-meta" data-cy="instant-messaging-message-info">
                {{getMessageTime(page.xauditModifiedOn)}}
              </div>
            </div>
            @if (page.dataNotification.enumNotificationPriorityID === PRIORITY_HIGH) {
              <span class="im-priority-badge" matTooltip="High priority" data-cy="instant-messaging-priority-badge">!</span>
            }
          }
        </div>
      }
    </div>
  }
</div>
